import { HttpService } from '../services'

export enum ReportType {
  VACATION = 33,
}

export default async function useMetabase(dashboardType: ReportType) {
  const http = new HttpService()
  const response = await http.get<{ url: string }>(
    '/user/metabase/' + dashboardType
  )
  console.log(response.data.url)
  return response.data.url
}
